import { api } from './client';
import type { Book } from './books';
import type { ReadingList, BookCollection } from '../types/models';

export interface ListWithBooks extends ReadingList {
  books: Book[];
}

export interface ListPreviewBook {
  id: number;
  coverPath?: string;
}

export interface ListWithPreviews extends ReadingList {
  previewBooks: ListPreviewBook[];
}

export async function getLists(owner?: 'mine'): Promise<ReadingList[]> {
  const params = owner ? '?owner=mine' : '';
  return api.get<ReadingList[]>(`/api/lists${params}`);
}

export async function getListsWithPreviews(owner?: 'mine'): Promise<ListWithPreviews[]> {
  const params = owner ? '?owner=mine' : '';
  return api.get<ListWithPreviews[]>(`/api/lists/previews${params}`);
}

export async function getListChildren(parentId: number): Promise<ReadingList[]> {
  return api.get<ReadingList[]>(`/api/lists?parent_id=${parentId}`);
}

export async function getList(id: number): Promise<ListWithBooks> {
  const [list, books] = await Promise.all([
    api.get<ReadingList>(`/api/lists/${id}`),
    api.get<Book[]>(`/api/lists/${id}/books`),
  ]);
  return { ...list, books };
}

export async function createList(data: { name: string; description?: string }): Promise<ReadingList> {
  return api.post<ReadingList>('/api/lists', data);
}

export async function updateList(id: number, data: Partial<ReadingList>): Promise<ReadingList> {
  return api.patch<ReadingList>(`/api/lists/${id}`, data);
}

export async function deleteList(id: number): Promise<void> {
  return api.delete<void>(`/api/lists/${id}`);
}

export async function addBookToList(listId: number, bookId: number): Promise<void> {
  return api.post<void>(`/api/lists/${listId}/books`, { book_id: bookId });
}

export async function removeBookFromList(listId: number, bookId: number): Promise<void> {
  return api.delete<void>(`/api/lists/${listId}/books/${bookId}`);
}

export async function getBookLists(bookId: number): Promise<BookCollection[]> {
  const resp = await api.get<{ lists: BookCollection[] }>(`/api/books/${bookId}/lists`);
  return resp.lists ?? [];
}
